import React from 'react'

const Title = ({title}) => {
  return (
    <div>
        <h1 className="title-font text-center mb-4 text-2xl font-medium text-fLetter sm:text-3xl font-airstrike">{title}</h1>

    </div>
  )
}

export default Title